import React, { useState } from 'react';
import { Layout, LayoutProps } from 'react-admin';
import { Box, Drawer, useMediaQuery, useTheme } from '@mui/material';
import { CustomAppBar } from './CustomAppBar';
import { CustomMenu } from './CustomMenu';
import { TimezoneProvider } from '../../contexts/TimezoneContext';

export const FixedLayout = (props: LayoutProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [collapsed, setCollapsed] = useState(false);
    const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
    const sidebarWidth = collapsed ? 80 : 280;

    return (
        <TimezoneProvider>
            <>
            <Box sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                height: '72px',
                zIndex: 1300,
            }}>
                <CustomAppBar
                    isMobile={isMobile}
                    onMenuToggle={() => setMobileDrawerOpen(prev => !prev)}
                />
            </Box>
            {isMobile ? (
                <Drawer
                    variant="temporary"
                    open={mobileDrawerOpen}
                    onClose={() => setMobileDrawerOpen(false)}
                    ModalProps={{ keepMounted: true }}
                    sx={{
                        '& .MuiDrawer-paper': {
                            width: 280,
                            top: '72px',
                            height: 'calc(100% - 72px)',
                        },
                    }}
                >
                    <CustomMenu onNavigate={() => setMobileDrawerOpen(false)} />
                </Drawer>
            ) : (
                <Box sx={{
                    position: 'fixed',
                    left: 0,
                    top: '72px',
                    bottom: 0,
                    width: `${sidebarWidth}px`,
                    zIndex: 1200,
                    transition: 'width 0.3s',
                }}>
                    <CustomMenu onCollapseChange={setCollapsed} />
                </Box>
            )}
            <Box sx={{
                marginLeft: isMobile ? 0 : `${sidebarWidth}px`,
                marginTop: '72px',
                transition: 'margin-left 0.3s',
                backgroundColor: isMobile ? 'transparent' : '#F8F9FA',
                height: 'calc(100vh - 72px)',
                overflow: 'auto',
                overflowX: 'hidden',
                position: 'relative',
                '&::-webkit-scrollbar': {
                    width: '8px',
                },
                '&::-webkit-scrollbar-track': {
                    background: 'rgba(0, 0, 0, 0.05)',
                    borderRadius: '4px',
                },
                '&::-webkit-scrollbar-thumb': {
                    background: 'rgba(0, 0, 0, 0.15)',
                    borderRadius: '4px',
                    '&:hover': {
                        background: 'rgba(0, 0, 0, 0.25)',
                    },
                },
            }}>
                <Layout
                    {...props}
                    appBar={() => null}
                    menu={() => null}
                    sx={{
                        '&.layout': {
                            marginTop: 0,
                            minHeight: 'auto',
                            minWidth: 0,
                            backgroundColor: 'transparent',
                        },
                        '& .RaLayout-appFrame': {
                            marginTop: 0,
                            minHeight: 'auto',
                            backgroundColor: 'transparent',
                        },
                        '& .RaLayout-contentWithSidebar': {
                            backgroundColor: 'transparent',
                        },
                        '& .RaLayout-main': {
                            backgroundColor: 'transparent',
                        },
                        '& .RaLayout-content': {
                            padding: isMobile ? '8px' : '24px 40px',
                            backgroundColor: 'transparent',
                            minHeight: 'auto',
                            '& > div': {
                                minHeight: 'auto',
                            },
                        },
                        '& .MuiDrawer-root': {
                            display: 'none',
                        },
                        '& .RaEdit-main, & .RaCreate-main': {
                            overflow: isMobile ? 'hidden' : 'visible',
                        },
                    }}
                />
            </Box>
        </>
        </TimezoneProvider>
    );
};
